export const getQuestionnaire = () => {
  return require('core/service/data-config/investment/questionnaire.json')
}

export const getQuestionnaireV2 = () => {
  return require('core/service/data-config/investment/questionnaireV2.json')
}

export const getForeignExchangeRiskQuestion = (questionnaires) => {
  return questionnaires.find((question) => question.id === 11)
}

export const isSelectedYesOnForeignExchangeRiskQuestion = (questionnaires) => {
  const foreignExchangeRiskQuestion = getForeignExchangeRiskQuestion(questionnaires)
  return foreignExchangeRiskQuestion?.selectedChoice && foreignExchangeRiskQuestion?.selectedChoice === 1
}

export const requireRADocument = (hasOverRiskFunds, hasForeignFunds, isSelectedYesOnForeignExchangeQuestion) => {
  return hasOverRiskFunds || (hasForeignFunds && !isSelectedYesOnForeignExchangeQuestion)
}
